import { useQuery } from "react-query";
import axios from "axios";
import {useSelector } from "react-redux";
import {apiUrlSelector} from "../redux/selectors";

export const useBOMs = () => {
    const apiUrl = useSelector(apiUrlSelector);
    return useQuery(["boms", apiUrl], () =>
        axios.get(`${apiUrl}bill-of-materials`).then(res => res.data.data),
        {
            refetchOnWindowFocus: false,
            placeholderData: []
        }
    );
};

export default useBOMs;